import { OfferRequirements, User } from '../../../../graphql/API';
import { ExtendedOfferRequirements } from './types';

export const calculateInviteCost = (users: User[]) =>
  users.reduce((prev, crr) => prev + (crr.inviteCredits ?? 0), 0);

export const collabRequirementPrices = {
  story: 10,
  stories3x: 25,
  stories2x: 20,
  feed: 50,
  reel: 100,
  tiktok: 50,
};

export const inviteRequirementPrice: Record<string, number> = {
  [OfferRequirements.postOnInstagramStories]: collabRequirementPrices.story,
  [OfferRequirements.postOnInstagramStories3x]: collabRequirementPrices.stories3x,
  [OfferRequirements.postOnInstagramStories2x]: collabRequirementPrices.stories2x,
  [OfferRequirements.postOnInstagramFeed]: collabRequirementPrices.feed,
  [OfferRequirements.postOnInstagramReels]: collabRequirementPrices.reel,
  [OfferRequirements.postOnTikTokVideo]: collabRequirementPrices.tiktok,
  [ExtendedOfferRequirements.noRequirement]: 0,
};
